const SEARCH_QUERY_UPDATED = (state, query) => {
  state.searchQuery = query
}

const SEARCH_CONTEXT_UDPATED = (state, context) => {
  state.searchContext = context
}

const SEARCH_COURSES_RESULT_COUNT = (state, count) => {
  state.coursesResultCount = count
}

const SEARCH_PLAYLISTS_RESULT_COUNT = (state, count) => {
  state.playlistsResultCount = count
}

const SEARCH_VIDEOS_RESULT_COUNT = (state, count) => {
  state.videosResultCount = count
}

const SEARCH_VIEW_STYLE_UPDATED = (state, viewStyle) => {
  state.viewStyle = viewStyle
}

const SEARCH_IS_FILTERS_COLLAPSED_UPDATED = (state, isFiltersCollapsed) => {
  state.isFiltersCollapsed = isFiltersCollapsed
}

export default {
  SEARCH_QUERY_UPDATED,
  SEARCH_CONTEXT_UDPATED,
  SEARCH_COURSES_RESULT_COUNT,
  SEARCH_PLAYLISTS_RESULT_COUNT,
  SEARCH_VIDEOS_RESULT_COUNT,
  SEARCH_VIEW_STYLE_UPDATED,
  SEARCH_IS_FILTERS_COLLAPSED_UPDATED,
}
